import React from 'react';
import { X } from 'lucide-react';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
    footer?: React.ReactNode;
    maxWidth?: string;
}

const Modal: React.FC<ModalProps> = ({
    isOpen,
    onClose,
    title,
    children,
    footer,
    maxWidth = 'max-w-md'
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4">
            <div
                className="modal-backdrop animate-fade-in"
                onClick={onClose}
            />
            <div className={`modal-legal w-full ${maxWidth} max-h-[90vh] sm:max-h-[85vh] p-4 sm:p-6 animate-scale-in relative z-50 flex flex-col`}>
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 transition-colors p-1 hover:bg-slate-100 rounded-full"
                >
                    <X size={20} />
                </button>

                <h3 className="text-lg font-semibold text-navy mb-4 pr-8 flex-shrink-0">{title}</h3>

                <div className="space-y-4 overflow-y-auto pr-1">
                    {children}
                </div>

                {footer && (
                    <div className="mt-4 sm:mt-6 pt-4 border-t border-slate-100 flex-shrink-0">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Modal;
